import { GET_DELIVERY_AGENT_PAYMENT_SUMMARY } from "../constants/endpoints";
import axiosClient from "./axios";

class DeliveryAgentPaymentSummaryService {
  static async getDeliveryAgentPaymentSummary(
    shopId: string,
    startDate: string,
    endDate: string
  ) {
    const response = await axiosClient.post(
      GET_DELIVERY_AGENT_PAYMENT_SUMMARY,
      {
        shopId,
        startDate,
        endDate,
      }
    );
    return response;
  }
}

export default DeliveryAgentPaymentSummaryService;
